module.exports = "../study/imgs/maps/Nagano/GWQ8/Climate/SnowDepth/Nagano_SnowDepth_MRI_RCP85_End.png";